import React from 'react';
import { SubmissionCommentIndexView } from '../../../types/submission_comments';
import { UserId } from '../../../../mainv2/types/user';
import { SubmissionCommentItem } from './SubmissionCommentItem';
import { LoaderRow } from '../../atoms/layout/LoaderRow';

export type Props = {
    viewerId: UserId;
    comments: SubmissionCommentIndexView[];
    loading: boolean;
};

export const SubmissionCommentList = ({ comments, viewerId, loading }) => {
    return (
        <div>
            {comments.map((comment) => (
                <SubmissionCommentItem
                    key={comment.id}
                    comment={comment}
                    background={comment.user_id === viewerId ? 'blue' : 'white'}
                />
            ))}
            {loading && <LoaderRow />}
        </div>
    );
};
